<div class="motors-vehicle-details-page">
  <tg-row>
    <tg-col md="8">
      <tg-row>
        <tg-col>
          <h1 class="motors-vehicle-details-page__title">
            Tell us about your boat
          </h1>
        </tg-col>
      </tg-row>
      <tg-row>
        <tg-col>
          <p class="motors-vehicle-details-page__sub-title p-lead-copy">
            Advertise to thousands of buyers everyday.
          </p>
        </tg-col>
      </tg-row>
    </tg-col>
    <tg-col md="4">
      <motors-cannot-edit-something-message-section [isVehicleDetails]="true">
      </motors-cannot-edit-something-message-section>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="motors-vehicle-details-page__section">
      <motors-vehicle-details-details-section></motors-vehicle-details-details-section>
    </tg-col>
  </tg-row>
</div>
